const routes = [{
  path: '/role',
  component: () => import('@/views/role'),
  name: 'role',
  meta: {
    title: '组织管理/角色管理'
  }
}, {
  path: '/role/custom',
  component: () => import('@/views/role/custom'),
  name: 'role-custom',
  meta: {
    title: '组织管理/角色管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/role.js